module.exports = "/_next/static/images/a325978cae2428d1f664dee585e53410-girl-and-card-lg.png.webp";